module.exports = __webpack_public_path__ + "img/Angiogenesis-BRCA_her2st.aa96ea47.png";